export default "__VITE_ASSET__CTym4A6C__"